import 'core-js/es/array/includes';
import jsSHA from 'jssha';

const jaEra: {[key: string]: number} = {
  "1": 1868,
  "2": 1912,
  "3": 1926,
  "4": 1989,
  "5": 2019
};
// 返戻レセプトデータ識別コード
//
// オンラインによる一次請求返戻ファイル及び再審査等返戻ファイル並びに再請求ファイルに係る記録条件仕様（調剤用）
// p.14 「第２章 一次請求返戻ファイルに係る記録条件仕様」『４ 情報表記仕様』
// p.38 「第３章 再審査等返戻ファイルに係る記録条件仕様」『４ 情報表記仕様』より
const returnReceiptCodes = ["1", "2", "3", "4", "5", "6", "8", "11", "12", "13", "14", "15", "16", "85", "86"];

export function hashFile(fileContents: string): string {
  return fileContents.split("\r\n").map((line: string) => {
    return hashingColumns(line.split(","));
  }).join("\r\n");
}

function hashingColumns(columns: string[]): string {
  const code = columns[0];
  if (returnReceiptCodes.includes(code)) {
    // 最初のカラムが返戻レセプトデータ識別コードと一致する場合
    // 最初の3列を切り出し、以降のカラムについてハッシュ化処理を行う
    return columns.slice(0, 3).join(",") + "," + hashingColumns(columns.slice(3));
  }
  switch (code) {
    case "RE":
      return hashingRE(columns);
    case "HO":
      return hashingHO(columns);
    case "KO":
      return hashingKO(columns);
    case "SN":
      return hashingSN(columns);
    default:
      return columns.join(",");
  }
}

function hashingRE(columns: string[]): string {
  // 5:氏名, 15-34:保険医師名, 35:麻薬免許番号, 42:カタカナ(氏名) をハッシュ化する
  const birthAndGender = convertDate(columns[6]) + columns[5];
  columns[4] = patientNameHash(columns[4], birthAndGender);
  for (let index = 14; index <= 33; index++) {
    if (columns[index].length > 0) {
      columns[index] = doctorNameHash(columns[index]);
    }
  }
  if (columns[34].length > 0) {
    columns[34] = computeHash(columns[34]);
  }
  if (columns[41] && columns[41].length > 0) {
    columns[41] = patientNameHash(columns[41], birthAndGender);
  }
  return columns.join(",");
}

function hashingHO(columns: string[]): string {
  // 2:保険者番号、3:被保険者記号、4:被保険者番号 をハッシュ化する
  [1, 2, 3].forEach((i) => {
    columns[i] = computeHash(columns[i]);
  });
  return columns.join(",");
}

function hashingKO(columns: string[]): string {
  // 3:公費負担医療受給者番号 をハッシュ化する
  columns[2] = computeHash(columns[2]);
  return columns.join(",");
}

function hashingSN(columns: string[]): string {
  /*
  4:保険者番号等（資格確認）
  5:被保険者証（手帳）等の記号（資格確認）
  6:被保険者証（手帳）等の番号（資格確認）
  8:受給者番号
  上記項目をハッシュ化する
  */
  [3,4,5,7].forEach((i) => {
    if (columns[i].length > 0) {
      columns[i] = computeHash(columns[i]);
    }
  });
  return columns.join(",");
}

function patientNameHash(name: string, birthAndGender: string): string {
  return computeHash(compactName(name) + birthAndGender);
}

function doctorNameHash(name: string): string {
  return computeHash(compactName(name));
}

function compactName(name: string): string {
  // 全角スペースを除外する
  return name.replace(/　/g, '');
}

function convertDate(dateStr: string): string {
  // GYYMMDD もしくは YYYYMMDD を YYYY/MM/DD に変換する
  const dateRe = /^(\d{1,2})(\d{2})(\d{2})(\d{2})$/;
  const [matched, prefix, yy, mm, dd] = Array.from(dateRe.exec(dateStr) || []);
  if (matched === undefined) {
    throw new Error(`Unmatched Data String: ${dateStr}`);
  }
  let year: string;
  if (prefix.length === 2) {
    year = prefix.concat(yy);
  } else {
    const offset = jaEra[prefix];
    if (offset === undefined) {
      throw new Error(`Unknown japanese era code: ${dateStr}`);
    }
    year = (offset + parseInt(yy, 10) - 1).toString();
  }
  return [year, mm, dd].join("/");
}

function computeHash(str: string): string {
  const shaObj = new jsSHA('SHA-1', 'TEXT', { encoding: 'UTF16LE'});
  shaObj.update(str);
  const shaObj256 = new jsSHA('SHA-256', 'TEXT', { encoding: 'UTF8'});
  shaObj256.update(str);
  return [shaObj.getHash('HEX'), shaObj256.getHash('HEX')].join("|");
}
